/**
 * ****************************************************************************
 * @description     :   Route for gs module
 * @created at      :   2023/07/11
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const gs0030i = () => import('@/views/gs/gs0030i');
const gs0050v = () => import('@/views/gs/gs0050v');
const gs0510v = () => import('@/views/gs/gs0510v');
const gs0710i = () => import('@/views/gs/gs0710i');
const gs0720v = () => import('@/views/gs/gs0720v');
const gs0194v = () => import('@/views/gs/gs0194v');
const gs0090i = () => import('@/views/gs/gs0090i');
const gs0193v = () => import('@/views/gs/gs0193v');
const gs0520i = () => import('@/views/gs/gs0520i');
const gs0560i = () => import('@/views/gs/gs0560i');
const gs0570i = () => import('@/views/gs/gs0570i');
const gs0080i = () => import('@/views/gs/gs0080i');
const gs0360v = () => import('@/views/gs/gs0360v');
const gs0060v = () => import('@/views/gs/gs0060v');
const gs0540i = () => import('@/views/gs/gs0540i');
const gs0610i = () => import('@/views/gs/gs0610i');
const gs9061i = () => import('@/views/gs/gs9061i');
const gs0140i = () => import('@/views/gs/gs0140i');
const gs0711v = () => import('@/views/gs/gs0711v');
const gs0110i = () => import('@/views/gs/gs0110i');

/**
 * Defined Router
 */
const resource = 'gs';
export default [
    {
        path: `/${resource}/gs0030i`,
        name: 'Gs0030i',
        component: gs0030i,
        meta: {
            title: '打刻専用',
            isPublic: true
        }
    },
    {
        path: `/${resource}/gs0050v`,
        name: 'Gs0050v',
        component: gs0050v,
        meta: {
            title: '承認待ち一覧',
            spScreen: '/gm/gm0070i'
        }
    },
    {
        path: `/${resource}/gs0510v`,
        name: 'Gs0510v',
        component: gs0510v,
        meta: {
            title: 'タイムレコーダー',
            spScreen: '/gm/gm0020i'
        }
    },
    {
        path: `/${resource}/gs0710i`,
        name: 'Gs0710i',
        component: gs0710i,
        meta: {
            title: 'アラート（本人）',
            spScreen: '/gm/gm0060v'
        }
    },
    {
        path: `/${resource}/gs0720v`,
        name: 'Gs0720v',
        component: gs0720v,
        meta: {
            title: 'アラート詳細',
            spScreen: '/gm/gm0061v'
        }
    },
    {
        path: `/${resource}/gs0194v`,
        name: 'Gs0194v',
        component: gs0194v,
        meta: {
            title: '個人設定'
        }
    },
    {
        path: `/${resource}/gs0090i`,
        name: 'Gs0090i',
        component: gs0090i,
        meta: {
            title: '事由区分の設定'
        }
    },
    {
        path: `/${resource}/gs0193v`,
        name: 'Gs0193v',
        component: gs0193v,
        meta: {
            title: '年次有給休暇の状況',
            spScreen: '/gm/gm0050v'
        }
    },
    {
        path: `/${resource}/gs0520i`,
        name: 'Gs0520i',
        component: gs0520i,
        meta: {
            title: '勤怠実績・各種申請',
            spScreen: '/gm/gm0040i'
        }
    },
    {
        path: `/${resource}/gs0560i`,
        name: 'Gs0560i',
        component: gs0560i,
        meta: {
            title: 'ワークフロー設定'
        }
    },
    {
        path: `/${resource}/gs0570i`,
        name: 'Gs0570i',
        component: gs0570i,
        meta: {
            title: '従業員情報の一括設定'
        }
    },
    {
        path: `/${resource}/gs0080i`,
        name: 'Gs0080i',
        component: gs0080i,
        meta: {
            title: '36協定の設定'
        }
    },
    {
        path: `/${resource}/gs0360v`,
        name: 'Gs0360v',
        component: gs0360v,
        meta: {
            title: '勤怠実績一覧',
            spScreen: '/gm/gm0030v'
        }
    },
    {
        path: `/${resource}/gs0060v`,
        name: 'Gs0060v',
        component: gs0060v,
        meta: {
            title: '勤怠モニタ',
            spScreen: '/gm/gm0090v'
        }
    },
    {
        path: `/${resource}/gs0540i`,
        name: 'Gs0540i',
        component: gs0540i,
        meta: {
            title: '就業規則の設定'
        }
    },
    {
        path: `/${resource}/gs0610i`,
        name: 'Gs0610i',
        component: gs0610i,
        meta: {
            title: 'シフト管理'
        }
    },
    {
        path: `/${resource}/gs9061i`,
        name: 'Gs9061i',
        component: gs9061i,
        meta: {
            title: 'タイムレコード送受信'
        }
    },
    {
        path: `/${resource}/gs0140i`,
        name: 'Gs0140i',
        component: gs0140i,
        meta: {
            title: '年次有給休暇の設定'
        }
    },
    {
        path: `/${resource}/gs0711v`,
        name: 'Gs0711v',
        component: gs0711v,
        meta: {
            title: 'アラート一覧',
            spScreen: '/gm/gm0080v'
        }
    },
    {
        path: `/${resource}/gs0110i`,
        name: 'Gs0110i',
        component: gs0110i,
        meta: {
            title: 'アラート設定'
        }
    }
];
